import { AfterViewInit, Directive, ElementRef, Input, OnChanges } from '@angular/core';
import { Language, TranslationService } from '../shared/services/translation.service';

@Directive({ selector: '[translate]' })
export class TranslateDirective implements AfterViewInit, OnChanges {
  @Input() language: Language;
  @Input() showTranslation = false;
  text: string;
  translation = '';

  constructor(
    private element: ElementRef,
    private translationService: TranslationService
  ) {}

  ngAfterViewInit() {
    if (this.element.nativeElement.innerText) {
      this.text = this.element.nativeElement.innerText;
      this.getTranslation();
    }
  }

  ngOnChanges() {
    this.getTranslation();
  }

  getTranslation() {
    if (!!this.text && !!this.language) {
      this.translationService
        .getTranslation(this.text, this.language.language)
        .subscribe((result) => {
          this.translation = result;
          if (this.showTranslation) {
            this.element.nativeElement.innerText = this.translation;
          } else {
            this.element.nativeElement.innerText = this.text;
          }
        });
    }
  }
}
